export default "__VITE_ASSET__DWobC$Id__"